/* MARMOT: OpenAI Ads Measurement Pixel (бриф openai-reklami-izmervane, 21.09.2026).
   Vanilla, defer, един файл + marmot-openai-ads-logic.js за чистата логика.

   Какво прави:
   - Стъбът `oaiq` с опашка се слага веднага, с `consent=false` и `init` в нея.
     При вмъкване на SDK-то (тоест при съгласие) `consent=false` се маха от
     опашката – иначе SDK-то го преиграва и трие `__oppref`/`__obref` на всяка
     следваща страница (видяно на живо, 21.09.2026).
     Самото SDK (bzrcdn.openai.com) се зарежда ЧАК след маркетингово съгласие:
     без съгласие SDK-то праща диагностична заявка към bzr.openai.com и пише
     `__oaiq_consent` (проверено с харнес, 21.09.2026) – което нарушава
     критерий 3 на брифа. Затова снипетът не е официалният едно към едно.
   - До решение за съгласието `oppref` се пази само в адреса: capture слушател
     го добавя при клик към позволените вътрешни връзки. При съгласие SDK-то го
     поема; при изричен отказ параметърът се маха от адреса. Ако Privacy API
     изобщо не се появи, допълването спира консервативно.
   - Съгласието идва от Shopify Customer Privacy API (marketingAllowed и
     currentVisitorConsent) и от visitorConsentCollected. Оттегляне изтрива
     бисквитките и `_oppref`/`_obref` от количката.
   - contents_viewed: само на продуктова страница, веднъж, след съгласие.
   - items_added: само след УСПЕШЕН отговор на POST /cart/add(.js) – през
     обвивка на window.fetch за картите/рафта и през sessionStorage маркер за
     родната форма на продуктовата страница, която напуска страницата (маркерът
     се брои само ако се кацне на return_to, тоест на /cart). Бройките са
     ЗАЯВЕНИТЕ от тялото на заявката – отговорът носи общото количество на реда.
     „+" в количката (POST /cart/change) се брои като положителна разлика спрямо
     последната известна снимка на количката; без снимка – нищо.
   - checkout_started, _oppref и _obref: извикват се от marmot-delivery-popup.js
     през window.MarmotOpenAiAds (веднъж на отваряне, пазено от попъпа).
   - order_created НЕ се праща от браузъра (Editera CAPI, отделен бриф).
   Всичко е в try/catch и никога не бива да спъне количката или checkout-а. */
(function () {
  'use strict';
  if (window.__marmotOpenAiAdsInit) return;
  window.__marmotOpenAiAdsInit = true;

  var PIXEL_ID = 'VqDXFYYKxzKWUxjNVz4AXc';
  var SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  var OPPREF_ATTRIBUTE = '_oppref';
  var OPPREF_COOKIE = '__oppref';
  var OBREF_COOKIE = '__obref';
  var PIXEL_COOKIES = ['__oppref', '__obref', '__oaiq_consent'];
  var PIXEL_STORAGE_KEY = 'oaiq_consent';
  var PENDING_ADD_KEY = 'marmot_oai_pending_add';
  var PRIVACY_POLL_MS = 250;
  var PRIVACY_POLL_TRIES = 32;

  var LOGIC = window.MarmotOpenAiAdsLogic;
  if (!LOGIC) return;

  var debug = LOGIC.debugRequested(window.location.search);
  var consentGranted = false;
  var consentResolved = false;
  var decorateLinks = false;
  var landingOppref = LOGIC.opprefFromUrl(window.location.href);
  var sdkRequested = false;
  var viewedSent = false;
  var nativeFetch = window.fetch;
  // Последната известна количка (key на ред → бройки) за разликите при /cart/change.
  // Поредният номер пази по-стар отговор да не презапише по-нова снимка.
  var cartSnapshot = null;
  var cartRequestSeq = 0;
  var cartSnapshotSeq = 0;

  function log() {
    if (!debug || !window.console || typeof window.console.info !== 'function') return;
    try { window.console.info.apply(window.console, ['[marmot-oai]'].concat([].slice.call(arguments))); } catch (e) { /* тихо */ }
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function eventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (e) { /* пада на резервата */ }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /* ---- Стъб с опашка (официалният образец, без зареждане на скрипта) ---- */
  function installQueue() {
    if (typeof window.oaiq === 'function') return;
    var q = function () { q.q.push(arguments); };
    q.q = [];
    window.oaiq = q;
  }

  function oaiq() {
    try {
      if (typeof window.oaiq === 'function') window.oaiq.apply(null, arguments);
    } catch (e) { log('oaiq отказа', e); }
  }

  function measure(name, payload) {
    if (!consentGranted || !payload) return false;
    oaiq('measure', name, payload, { event_id: eventId() });
    log('measure', name, payload);
    return true;
  }

  function loadSdk() {
    if (sdkRequested) return;
    sdkRequested = true;
    try {
      // Стъбът носи consent=false; преиграе ли го SDK-то, трие __oppref/__obref
      // (на всяка страница след съгласието). Маха се преди вмъкването.
      if (window.oaiq && window.oaiq.q) window.oaiq.q = LOGIC.queueWithoutDeniedConsent(window.oaiq.q);
    } catch (e) { log('опашката не се изчисти', e); }
    try {
      var script = document.createElement('script');
      script.async = true;
      script.src = SDK_URL;
      script.onerror = function () { log('SDK-то не се зареди'); };
      (document.head || document.documentElement).appendChild(script);
    } catch (e) { log('SDK-то не се вмъкна', e); }
  }

  /* ---- Съгласие ---- */
  function expirePixelCookies() {
    try {
      var host = window.location.hostname;
      for (var i = 0; i < PIXEL_COOKIES.length; i++) {
        if (!LOGIC.readCookie(document.cookie, PIXEL_COOKIES[i])) continue; // няма я – без шум в DevTools
        var strings = LOGIC.cookieExpireStrings(PIXEL_COOKIES[i], host);
        for (var j = 0; j < strings.length; j++) document.cookie = strings[j];
      }
      if (window.localStorage && window.localStorage.getItem(PIXEL_STORAGE_KEY) != null) window.localStorage.removeItem(PIXEL_STORAGE_KEY);
    } catch (e) { /* без достъп до бисквитки/хранилище – няма какво да трием */ }
    try {
      // SDK-то пише и oaiq_cs:<pixel> в sessionStorage (харнес 30.10, v0.1.97).
      if (window.sessionStorage) {
        var keys = [];
        for (var k = 0; k < window.sessionStorage.length; k++) keys.push(window.sessionStorage.key(k));
        var own = LOGIC.pixelSessionKeys(keys);
        for (var m = 0; m < own.length; m++) window.sessionStorage.removeItem(own[m]);
      }
    } catch (e) { /* без достъп до хранилището – няма какво да трием */ }
  }

  function applyConsent(allowed) {
    var wasResolved = consentResolved;
    var wasGranted = consentGranted;
    consentResolved = true;
    decorateLinks = false;
    if (allowed === true) {
      if (consentGranted) return;
      consentGranted = true;
      log('съгласие: да');
      oaiq('consent', true);
      loadSdk();
      sendContentsViewed();
      primeCartSnapshot();
    } else {
      consentGranted = false;
      log('съгласие: не');
      // Стъбът вече носи consent=false; има смисъл да се повтаря само пред заредено SDK.
      if (sdkRequested) oaiq('consent', false);
      expirePixelCookies();
      removeOpprefFromAddress();
      if (wasGranted) clearPixelCartAttributes();
    }
    if (!wasResolved) consumePendingAdd();
  }

  function marketingAllowedNow() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.marketingAllowed === 'function') return api.marketingAllowed() === true;
    } catch (e) { /* без API няма съгласие */ }
    return false;
  }

  function currentVisitorConsent() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.currentVisitorConsent === 'function') return api.currentVisitorConsent();
    } catch (e) { /* непознато */ }
    return null;
  }

  function privacyStateNow() {
    return LOGIC.consentState(marketingAllowedNow(), currentVisitorConsent());
  }

  function applyPrivacyState(state) {
    if (state === 'granted') applyConsent(true);
    else if (state === 'denied') applyConsent(false);
    else {
      // Не е избрано: следи от стар избор не се пазят, кликът живее само в адреса.
      expirePixelCookies();
      decorateLinks = !!landingOppref;
    }
  }

  function removeOpprefFromAddress() {
    try {
      var clean = LOGIC.urlWithoutOppref(window.location.href);
      if (clean && window.history && typeof window.history.replaceState === 'function') {
        window.history.replaceState(window.history.state, '', clean);
      }
    } catch (e) { /* адресът остава непроменен */ }
  }

  function watchConsent() {
    document.addEventListener('visitorConsentCollected', function (e) {
      try {
        var allowed = LOGIC.consentFromEvent(e && e.detail);
        if (allowed === true) applyConsent(true);
        else if (allowed === false) applyConsent(false);
        else applyPrivacyState(privacyStateNow());
      } catch (err) { /* тихо */ }
    });

    var tries = 0;
    (function poll() {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.marketingAllowed === 'function') {
        if (!consentResolved) applyPrivacyState(privacyStateNow());
        return;
      }
      tries++;
      if (tries === 1 && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { /* следващият опит го намира */ });
        } catch (e) { /* остава анкетата */ }
      }
      if (tries < PRIVACY_POLL_TRIES) setTimeout(poll, PRIVACY_POLL_MS);
      else {
        decorateLinks = false;
        log('Customer Privacy API не се появи; връзките вече не се допълват');
      }
    })();
  }

  /* Делегиран capture слушател: Lumia чете href в собствени click handlers,
     затова позволената връзка се променя преди тях. Няма обхождане на DOM. */
  function watchOpprefLinks() {
    function decorateClickedLink(e) {
      try {
        if (!decorateLinks || consentGranted || !landingOppref) return;
        var target = e && e.target;
        var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
        if (!link || !LOGIC.linkTargetAllowsDecoration(link.getAttribute('target'), link.hasAttribute('download'))) return;
        var href = link.getAttribute('href');
        var decorated = LOGIC.decorateHref(href, window.location.origin, landingOppref, window.location.href);
        if (decorated) {
          link.setAttribute('href', decorated);
          setTimeout(function () {
            try { if (link.getAttribute('href') === decorated) link.setAttribute('href', href); } catch (restoreError) { /* тихо */ }
          }, 0);
        }
      } catch (err) { /* навигацията продължава с оригиналния адрес */ }
    }
    document.addEventListener('click', decorateClickedLink, true);
    document.addEventListener('auxclick', decorateClickedLink, true);
  }

  /* ---- contents_viewed ---- */
  function viewHints() {
    var hints = {};
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      hints.selectedVariantId = meta && meta.selectedVariantId;
      var match = /[?&]variant=(\d+)/.exec(window.location.search);
      hints.urlVariantId = match ? match[1] : null;
      var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
      hints.formVariantId = field && field.value;
    } catch (e) { /* подсказките са по желание */ }
    return hints;
  }

  function sendContentsViewed() {
    if (viewedSent || !consentGranted) return;
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var payload = LOGIC.contentsViewedPayload(meta, viewHints());
      if (!payload) return;
      viewedSent = true;
      measure('contents_viewed', payload);
    } catch (e) { log('contents_viewed отказа', e); }
  }

  /* ---- items_added: fetch към /cart/add(.js) и /cart/change ---- */
  function rememberCart(json, seq) {
    var snap = LOGIC.cartSnapshot(json);
    if (!snap || seq < cartSnapshotSeq) return;
    cartSnapshotSeq = seq;
    cartSnapshot = snap;
  }

  function onCartResponse(kind, body, seq, response) {
    if (!response || typeof response.clone !== 'function') return;
    var status = response.status;
    response.clone().json().then(function (json) {
      if (kind === 'add') {
        if (LOGIC.addSucceeded(status, json)) {
          measure('items_added', LOGIC.itemsAddedPayload(json, LOGIC.addRequestQuantities(body)));
          if (seq >= cartSnapshotSeq) { cartSnapshotSeq = seq; cartSnapshot = LOGIC.snapshotWithAdded(cartSnapshot, json); }
        }
        return;
      }
      if (kind === 'change' && LOGIC.changeSucceeded(status, json)) {
        measure('items_added', LOGIC.contentsPayload(LOGIC.quantityDeltaLines(cartSnapshot, json)));
      }
      rememberCart(json, seq);
    }).catch(function () { /* не е JSON или е грешка – не е добавяне */ });
  }

  function wrapFetch() {
    if (typeof nativeFetch !== 'function') return;
    window.fetch = function (input, init) {
      var result = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && typeof input.url === 'string' ? input.url : String(input));
        var method = (init && init.method) || (input && input.method) || 'GET';
        var body = init ? init.body : undefined;
        var kind = LOGIC.cartRequestKind(url, method, body);
        if (kind && result && typeof result.then === 'function') {
          var seq = ++cartRequestSeq;
          result.then(function (response) { onCartResponse(kind, body, seq, response); }, function () { /* мрежов отказ – нищо */ });
        }
      } catch (e) { /* обвивката никога не пречи на заявката */ }
      return result;
    };
  }

  /* Снимка на количката на страницата на количката, за да има с какво да се
     сравни първото „+". Само след съгласие – без него не се праща нищо. */
  function primeCartSnapshot() {
    try {
      if (cartSnapshot || typeof nativeFetch !== 'function') return;
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var onCart = (meta && meta.page && meta.page.pageType === 'cart') || /(^|\/)cart\/?$/.test(window.location.pathname);
      if (!onCart) return;
      var seq = ++cartRequestSeq;
      nativeFetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { rememberCart(cart, seq); })
        .catch(function () { /* без снимка първото „+" просто не се брои */ });
    } catch (e) { /* тихо */ }
  }

  /* ---- items_added: родната форма на продуктовата страница ---- */
  function watchNativeAddForms() {
    document.addEventListener('submit', function (e) {
      try {
        var form = e.target;
        if (!consentGranted || !form || e.defaultPrevented || typeof form.getAttribute !== 'function') return;
        if (!LOGIC.isCartAddUrl(form.getAttribute('action') || '')) return;
        var data = new FormData(form);
        var marker = LOGIC.pendingAddMarker({ id: data.get('id'), quantity: data.get('quantity'), return_to: data.get('return_to') }, Date.now());
        if (marker && window.sessionStorage) window.sessionStorage.setItem(PENDING_ADD_KEY, JSON.stringify(marker));
      } catch (err) { /* без маркер няма събитие – по-добре пропуск, отколкото двойно */ }
    });
  }

  function consumePendingAdd() {
    var marker = null;
    try {
      if (!window.sessionStorage) return;
      var raw = window.sessionStorage.getItem(PENDING_ADD_KEY);
      if (!raw) return;
      window.sessionStorage.removeItem(PENDING_ADD_KEY);
      marker = JSON.parse(raw);
    } catch (e) { return; }
    if (!consentGranted || !LOGIC.pendingAddIsFresh(marker, Date.now())) return;
    // Провалено добавяне връща на продуктовата страница, не на return_to – тогава нищо.
    if (!LOGIC.pendingAddLanded(marker, window.location.pathname)) { log('маркерът не кацна на return_to – без items_added'); return; }
    try {
      var seq = ++cartRequestSeq;
      nativeFetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var lines = LOGIC.pendingAddLines(marker, cart, Date.now());
          measure('items_added', LOGIC.contentsPayload(lines));
          rememberCart(cart, seq);
        })
        .catch(function () { /* без количка няма събитие */ });
    } catch (e) { /* тихо */ }
  }

  /* ---- Публичен интерфейс за попъпа Ф2 ---- */
  function opprefValue() {
    if (!consentGranted) return '';
    try { return LOGIC.readCookie(document.cookie, OPPREF_COOKIE); } catch (e) { return ''; }
  }

  function obrefValue() {
    if (!consentGranted) return '';
    try { return LOGIC.readCookie(document.cookie, OBREF_COOKIE); } catch (e) { return ''; }
  }

  /* Връща true, щом има какво да се прати (пълна количка) – попъпът маркира
     отварянето като обработено и без съгласие, за да не праща късно. */
  function checkoutStarted(cart) {
    var payload = LOGIC.checkoutStartedPayload(cart);
    if (!payload) return false;
    measure('checkout_started', payload);
    return true;
  }

  /* Слага/маха _oppref и _obref с една заявка. Старият договор { key, value,
     attributes } остава за попъпа; attributes винаги е пълният резултат или
     сигурна локална резерва, за да не се разминава cartSignature. */
  function syncCartOppref(cart) {
    var plan = LOGIC.pixelAttributesPlan(cart, { oppref: opprefValue(), obref: obrefValue() });
    if (!plan.update || typeof nativeFetch !== 'function') return Promise.resolve(null);
    var fallback = LOGIC.cartAttributesAfterPlan(cart, plan.attributes);
    return nativeFetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: plan.attributes })
    }).then(function (r) {
      if (!r.ok) return null;
      log('OpenAI атрибути', plan.attributes);
      return r.json().then(function (json) {
        var attrs = json && json.attributes && typeof json.attributes === 'object' && !Array.isArray(json.attributes) ? json.attributes : null;
        return { key: OPPREF_ATTRIBUTE, value: plan.attributes._oppref, attributes: attrs || fallback };
      }, function () { return { key: OPPREF_ATTRIBUTE, value: plan.attributes._oppref, attributes: fallback }; });
    }).catch(function () { return null; });
  }

  function clearPixelCartAttributes() {
    if (typeof nativeFetch !== 'function') return;
    nativeFetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { return syncCartOppref(cart); })
      .catch(function () { /* оттеглянето не бива да спъва страницата */ });
  }

  window.MarmotOpenAiAds = {
    checkoutStarted: checkoutStarted,
    syncCartOppref: syncCartOppref,
    opprefValue: opprefValue,
    obrefValue: obrefValue,
    consentGranted: function () { return consentGranted; }
  };

  /* ---- Bootstrap ---- */
  try {
    installQueue();
    oaiq('consent', false);
    oaiq('init', debug ? { pixelId: PIXEL_ID, debug: true } : { pixelId: PIXEL_ID });
    wrapFetch();
    watchOpprefLinks();
    watchNativeAddForms();
    watchConsent();
  } catch (e) { log('bootstrap отказа', e); }
})();
